import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { Styled } from "./styles";
import Copyright from "@/components/layout/copyright";
import { useNavigate } from "react-router-dom";
import { AuthOperation } from "@/types/utils";
import constant from "@/utils/constant";

const Layout: React.FC = () => {
    const navigate = useNavigate();
    const path = useLocation().pathname;
    const [operation, setOperation] = useState<AuthOperation>(
        path === "/sign-up" ? "signup" : "login",
    );
    const { dippiLogo } = constant.ASSETS;

    useEffect(() => {
        document.getElementById("root")!.style.overflowY = "auto";
        return () => {
            document.getElementById("root")!.style.overflowY = "visible";
        };
    }, []);

    const onNavigate = () => {
        if (operation === "resetLink") navigate("/sign-in");
        if (operation === "signup") navigate("/sign-in");
        if (operation === "login") navigate("/sign-up");
    };

    if (path === "/sign-in" && operation !== "login") {
        setOperation("login");
    }
    if (path === "/sign-up" && operation !== "signup") {
        setOperation("signup");
    }
    if (path === "/reset-password" && operation !== "resetLink") {
        setOperation("resetLink");
    }

    return (
        <Styled.Container>
            <Box>
                <img src={dippiLogo} width={80} alt="dippi logo" />
                <Styled.Content>
                    <Outlet />
                    <Styled.Footer>
                        <Typography variant="body2" textAlign="center" marginRight="10px">
                            {operation === "login" ? "New to Dippi?" : "Already have an account?"}
                        </Typography>
                        <Button
                            data-testid="toggle-auth-form-button"
                            variant="text"
                            onClick={onNavigate}
                        >
                            {operation === "login" ? "Create account" : "Sign in"}
                        </Button>
                    </Styled.Footer>
                </Styled.Content>
                <Copyright isAuth={true} />
            </Box>
        </Styled.Container>
    );
};

export default Layout;
